/* src/app/shared-module/components/agent-city/agent-city.component.scss */
.city-list-section {
  padding: 1rem;
  background:
    linear-gradient(
      180deg,
      #f1f3f5 0%,
      #eceff2 100%);
  min-height: 100%;
  display: flex;
  justify-content: center;
}
.city-picker-card {
  width: min(100%, 980px);
  border-radius: 22px;
  overflow: hidden;
  border-color: #dde2e8;
  background: #f8fafb;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.07);
}
.city-picker-header {
  padding: 1.7rem 2rem 1.3rem;
}
.city-picker-header h2 {
  margin: 0;
  font-size: clamp(1.45rem, 1.3rem + 0.8vw, 1.95rem);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.01em;
  color: #232a32;
}
.city-picker-header p {
  margin: 0.45rem 0 0;
  font-size: 0.92rem;
  color: #5a6573;
  letter-spacing: 0.01em;
}
mat-divider {
  border-top-color: #d6dce2;
}
.city-grid {
  padding: 0;
  margin: 0;
}
.city-scroll-content {
  max-height: min(62vh, 520px);
  overflow-y: auto;
  padding: 1.45rem 1.2rem 1.35rem;
  overscroll-behavior: contain;
}
.city-scroll-content::-webkit-scrollbar {
  width: 8px;
}
.city-scroll-content::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.55);
  border-radius: 999px;
}
.city-scroll-content::-webkit-scrollbar-track {
  background: rgba(226, 232, 240, 0.45);
}
.city-col {
  padding: 0.42rem 0.32rem;
}
.city-footer {
  padding: 0.85rem 1.05rem 0.95rem;
  margin: 0;
}
.city-footer .close-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border-radius: 999px;
  font-weight: 600;
  padding: 0 0.95rem;
}
.city-footer mat-icon {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}
.city-option {
  appearance: none;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 16px;
  padding: 0.85rem 0.55rem;
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  outline: none;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.city-option:hover {
  background: rgba(148, 163, 184, 0.09);
  border-color: #d8dee6;
}
.city-option:focus-visible .city-image-wrap,
.city-option:hover .city-image-wrap {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.2);
}
.city-option:focus-visible {
  border-color: #5b8def;
  background: rgba(91, 141, 239, 0.08);
}
.city-option.is-selected {
  background: rgba(59, 130, 246, 0.12) !important;
  border-color: #5a8ef4 !important;
}
.city-option.is-selected p {
  color: #1f3d70;
  font-weight: 600;
}
.city-option.is-selected .city-image-wrap {
  box-shadow: 0 0 0 3px #5a8ef4, 0 10px 18px rgba(37, 99, 235, 0.24);
}
.city-option.is-selected:hover {
  background: rgba(59, 130, 246, 0.16) !important;
  border-color: #5a8ef4 !important;
}
.city-option p {
  margin: 0.75rem 0 0;
  font-size: clamp(1rem, 0.92rem + 0.35vw, 1.3rem);
  line-height: 1.2;
  font-weight: 500;
  color: #2f3945;
  word-break: break-word;
}
.city-image-wrap {
  width: clamp(80px, 10vw, 110px);
  height: clamp(80px, 10vw, 110px);
  border-radius: 50%;
  overflow: hidden;
  background: #e5e9ee;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.city-image-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.city-image-wrap .city-fallback-icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(2.2rem, 4vw, 3rem);
  color: #8b98a8;
  background:
    linear-gradient(
      160deg,
      #e7ebf0 0%,
      #dde3ea 100%);
}
.city-option-skeleton {
  padding: 0.85rem 0.55rem;
  align-items: center;
}
.city-option-skeleton .city-image-wrap {
  border-radius: 50%;
}
.city-option-skeleton .city-name-skeleton {
  margin: 0.75rem 0 0;
  width: 70%;
  height: 1rem;
  border-radius: 6px;
}
@media (max-width: 900px) {
  .city-picker-header {
    padding: 1.3rem 1.35rem 1.1rem;
  }
  .city-scroll-content {
    max-height: min(60vh, 500px);
    padding: 1.15rem 0.9rem 1.15rem;
  }
  .city-option p {
    font-size: clamp(0.98rem, 0.88rem + 0.75vw, 1.16rem);
  }
}
@media (max-width: 620px) {
  .city-list-section {
    padding: 0.55rem;
  }
  .city-picker-card {
    border-radius: 16px;
  }
  .city-scroll-content {
    max-height: 58vh;
    padding: 0.95rem 0.65rem 1rem;
  }
  .city-col {
    padding: 0.32rem 0.2rem;
  }
  .city-picker-header {
    padding: 1.05rem 0.95rem 0.9rem;
  }
  .city-picker-header h2 {
    font-size: 1.25rem;
  }
  .city-picker-header p {
    font-size: 0.84rem;
  }
  .city-option {
    padding: 0.65rem 0.3rem;
  }
  .city-option p {
    margin-top: 0.58rem;
    font-size: 0.96rem;
  }
  .city-image-wrap {
    width: 74px;
    height: 74px;
  }
  .city-footer {
    padding: 0.7rem 0.75rem 0.75rem;
  }
}
@media (max-width: 390px) {
  .city-scroll-content {
    max-height: 56vh;
    padding: 0.85rem 0.55rem 0.9rem;
  }
  .city-option {
    padding: 0.6rem 0.35rem;
  }
}
@media (hover: none) {
  .city-option:hover {
    background: transparent;
    border-color: transparent;
  }
  .city-option:hover .city-image-wrap {
    transform: none;
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.12);
  }
}
/*# sourceMappingURL=agent-city.component.css.map */
